import { useState } from "react";
import { copySheet, fixColumnCValues, focusCell, getWorksheetNames } from "../commands/common";
import { judgeEmptyFormSheet } from "../commands/questions/excelInfo";

export function useSheets() {
  const [sheets, setSheets] = useState<string[]>([]);
  const [itemSheets, setItemSheets] = useState<string[]>([]);

  async function loadSheetNames() {
    const sheetNames = await getWorksheetNames("form");
    setSheets(sheetNames);
    const itemSheetNames = await getWorksheetNames("item");
    setItemSheets(itemSheetNames);
  }

  const [selectedSheet, setSelectedSheet] = useState<string>("");

  const handleChangeSheet = (event: any) => {
    setSelectedSheet(event.target.value as string);
  };

  const [selectedItemSheet, setSelectedItemSheet] = useState<string>("");
  const handleChangeItemSheet = (event: any) => {
    setSelectedItemSheet(event.target.value as string);
  };

  const [editSheet, setEditSheet] = useState<string>("");

  async function updateEditSheet(sheetName: string) {
    const copiedSheetName = await copySheet(sheetName);
    await fixColumnCValues(copiedSheetName);
    setEditSheet(copiedSheetName);
    focusCell("B5", copiedSheetName);
  }

  const [baseSheet, setBaseSheet] = useState<"form" | "item">("form");

  function handleChangeBaseSheet(sheet: "form" | "item") {
    setBaseSheet((prev) => {
      if (prev === sheet) {
        return prev;
      } else {
        return sheet;
      }
    });
  }

  async function autoSetBaseSheet() {
    const isEmpty = await judgeEmptyFormSheet(selectedSheet);
    if (isEmpty && selectedItemSheet) {
      handleChangeBaseSheet("item");
    }
  }

  return {
    sheets,
    selectedSheet,
    handleChangeSheet,
    itemSheets,
    selectedItemSheet,
    handleChangeItemSheet,
    loadSheetNames,
    editSheet,
    updateEditSheet,
    baseSheet,
    handleChangeBaseSheet,
    autoSetBaseSheet,
  };
}
